import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Dropdown, Button, Popup, Icon} from 'semantic-ui-react';
import {tasksStatus} from '../../../../common/dictionaries/accessories';
import {Actions} from '../../../../common/actions';
import './taskPause.scss';

class ReasonToPauseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'reason': '',
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onSaveAssignmentClick = this.onSaveAssignmentClick.bind(this);
  }

  fetchData() {
    this.setState({'modalWasOpen': true});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false, 'reason': ''});
  }

  onSaveAssignmentClick() {
    const {order, serviceCode3, technicianSelected, type} = this.props;
    const data = {
      'technician': technicianSelected,
      'nextStatus': this.state.reason,
      'action': 'pause',
      'orderType': type,
    };
    this.props.addOrderTaskProgress(order, serviceCode3, data);
    this.onCloseModalClick();
  }
  
  getStatusOptions() {
    return this.props.taskStatusList.map((item) => {
      return {'text': item.description, 'value': item.id};
    });
  }

  changeReasonToPause(value) {
    this.setState({'reason': value});
  }
  
  render() {
    const {isRowDisabled, serviceCode3, status} = this.props;
    const {modalWasOpen, reason} = this.state;

    if (isRowDisabled || status !== tasksStatus.started_task) {
      return <Icon name='pause circle filled' color='gray' size='huge' className='keep-color-on-hover' />;
    }

    return (
      <Modal size='tiny' className='task-pause-modal'
        onOpen={() => this.fetchData()}
        open={modalWasOpen}
        trigger={
          <span>
            <Popup
              trigger={
                <Icon name='pause circle filled' color='yellow' size='huge' className='keep-color-on-hover pointer' />
              }
              content='Pausar Tarea'
              position='top center'
              inverted
            />
          </span>
        }>

        <Modal.Header>
          Pausar la tarea: {serviceCode3}
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
            <h3>Seleccione el motivo para pausar esta tarea:</h3>
            <Dropdown selection
              options={this.getStatusOptions()}
              search
              name='status-container'
              value={reason}
              onChange={(e, {value}) => this.changeReasonToPause(value)}
              placeholder='Seleccione Estado'
              noResultsMessage='Estado no encontrado'
            />
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          <Button positive
            disabled={!reason}
            onClick={this.onSaveAssignmentClick}>
            Guardar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'taskStatusList': state.timeMarked.taskStatusList,
  };
};

const {
  addOrderTaskProgress,
} = Actions;

export default connect(mapStateToProps, {
  addOrderTaskProgress,
})(ReasonToPauseModal);
